module.exports = __webpack_public_path__ + "img/8D.3ce263b6.svg";